import Vue from 'vue';
import Vuex from 'vuex';
// import { log } from 'console';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        //用户 token
        // jwt: '',
        Authorization:localStorage.getItem('Authorization')?localStorage.getItem('Authorization'):'',
        // 管理员登录用户名
        userName:null,
        // 管理员权限 0:超级管理员，1:管理员，2:职员
        role:null,
        plateNo:null,//车牌号码
        stationInfo:[],//服务站信息
        stationUserInfo:[],//服务站用户信息
        urlStationCode:null,// url 携带的服务站代码
        getStation:null,//号牌领取点
        certMessage:null,//用户填写的申请信息
        
        
    },
    mutations: {
        // 用户 jwt
        // setJwtToken(state, payload) {
        //     state.jwt = payload.jwt;
        // },

        // 修改token,并将token存入localStorage
        changeLogin(state,user){
            state.Authorization = user.Authorization
            localStorage.setItem('Authorization',user.Authorization)
        },

        // 保存登录的管理员用户名、管理权限
        setUserInfo(state,user){
            // debugger
            state.userName = user.userName
            state.role = user.role
        },  
        
        // 保存用户输入的车牌号码
        setPlateNo(state,plateNo){
            // debugger
            state.plateNo = plateNo
        },

        // 保存用户选择的业务受理点信息
        setStation(state,station){
            // debugger
            state.stationInfo = station
        },
        // 保存服务站登录用户的信息
        setStationUserInfo(state,user){
            state.stationUserInfo = user
        },
        // 保存 url 携带的服务站代码
        setUrlStationCode(state,stationCode){
            state.urlStationCode = stationCode
        },
        // 保存号牌领取点的信息
        setGetStationCode(state,station){
            state.getStation = station
        },
        // 保存用户填写的申请信息
        setCertMessage(state,msg){
            state.certMessage = msg
        },
    },
    
    actions: {
        // setUserName({commit},userName){
        //     commit('setUserName',userName)
        // }
    
    },
    getters:{
        // getJwtToken:function(state){
        //     return state.jwt
        // }
        // getUserName(state){
        //     return state.userName
        // }
    },
    modules: {},
});
